import { get } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

// Request Type

// Response Type

export type ImageInfo = {
  id: number
  parent_table_key: number
  original_name: string
  url: string
}

export type EventInfo = {
  id: number
  round: number
  event_type: string
  name: string
  status: string
  place: string
  start_date: string
  end_date: string
  show_date: string
  created_at: string
  delete_yn: string
  image: number
  image_info: ImageInfo
}

export interface OngoingEventResponse extends ApiResponse {
  data: {
    eventInfo: EventInfo
  }
}

// function
export const getOngoingEvent = async () => {
  const response: OngoingEventResponse = await get(`/main/ongoingEvent`)

  return response
}

export const getOngoingEventInfo = async (): Promise<EventInfo> => {
  const response: OngoingEventResponse = await get(`/main/ongoingEvent`)

  return response.data.eventInfo
}
